import { DateCalendar } from "@mui/x-date-pickers";
import moment from "moment";
import { useState } from "react";
import { useModalControl } from "../../customHooks/useModalControl";
import { useWindowDimensions } from "../../customHooks/useWindowDimensions";
import { formatDate } from "../../helperFunctions";
import { Icon } from "../icons/icon";
import { ModalComponent } from "../modals";
import { PopoverMenu } from "./popover";
import { TextInput } from "./textInput";

export const DateComp = ({
  clicked,
  date,
  minDate,
  referenceDate,
  setDate = () => {},
  className = "",
  disablePast = false,
  disableFuture = false,
}: {
  clicked?: boolean;
  date?: Date | null;
  minDate?: moment.Moment;
  referenceDate?: moment.Moment;
  setDate?: (date: moment.Moment | null) => void;
  className?: string;
  disablePast?: boolean;
  disableFuture?: boolean;
}) => {
  return (
    <div className={className}>
      <DateCalendar
        value={clicked && date === null ? moment(new Date()) : moment(date)}
        onChange={(newDate) => {
          setDate(newDate);
          // close();
        }}
        minDate={minDate}
        referenceDate={referenceDate}
        disablePast={disablePast}
        disableFuture={disableFuture}
        views={["year", "month", "day"]}
        sx={{
          "& .MuiPickersDay-root": {
            fontFamily: "Satoshi !important",
            fontWeight: 500,
          },
          "& .MuiPickersDay-root.Mui-selected": {
            backgroundColor: "#055139 !important",
            color: "white",
            fontFamily: "Satoshi !important",
          },
          "& .MuiYearCalendar-button": {
            fontSize: "14px",
            fontWeight: "500",
          },
          "& .MuiYearCalendar-button.Mui-selected": {
            backgroundColor: "#055139 !important",
            color: "white",
            fontFamily: "Satoshi !important",
          },
          "& .MuiMonthCalendar-button": {
            fontSize: "14px",
            fontWeight: "500",
          },
          "& .MuiMonthCalendar-button.Mui-selected": {
            backgroundColor: "#055139 !important",
            color: "white",
            fontFamily: "Satoshi !important",
          },
        }}
      />
    </div>
  );
};

export const DateInput = ({
  placeholder = "",
  errors = "",
  title = "",
  date,
  minDate,
  referenceDate,
  setDate = () => {},
  onBlur = () => {},
  className = "",
  inputClassName = "",
  name,
  disablePast = false,
  disableFuture = false,
  dateDisplayFormat,
  disabled = false,
}: {
  placeholder: string;
  name: string;
  errors?: string;
  title?: string;
  date?: Date | null;
  minDate?: moment.Moment;
  referenceDate?: moment.Moment;
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  setDate?: (date: moment.Moment | null) => void;
  className?: string;
  inputClassName?: string;
  disablePast?: boolean;
  disableFuture?: boolean;
  dateDisplayFormat?: string;
  disabled?: boolean;
}) => {
  const [clicked, setClicked] = useState<boolean>(false);

  const { modal, modalOpen, handleModalOpen, handleModalClose } =
    useModalControl();

  const { width } = useWindowDimensions();

  return (
    <>
      <PopoverMenu
        onPopoverClick={(e) => {
          e.stopPropagation();

          if (width < 768) {
            e.preventDefault();
            handleModalOpen("datePopOverMenuModal");
          }
        }}
        customMenuItems={({ close }) => {
          return (
            <DateComp
              clicked={clicked}
              date={date}
              minDate={minDate}
              referenceDate={referenceDate}
              setDate={setDate}
              className={className}
              disablePast={disablePast}
              disableFuture={disableFuture}
            />
          );
        }}
        menuClassName="rounded-xl bg-white !shadow-lg border z-[999]"
        className={`w-full`}
        position="bottom"
      >
        <button
          className="h-fit w-full text-left"
          type="button"
          disabled={disabled}
        >
          <TextInput
            type="text"
            name={name}
            value={formatDate(date, dateDisplayFormat)}
            placeholder={placeholder}
            onChange={() => {}}
            onBlur={(e) => {
              setClicked(true);
              onBlur(e);
            }}
            hasTitle={!!title}
            title={title}
            errors={errors}
            containerClassName=""
            readOnly={disabled}
            inputClass="!cursor-pointer"
            hasIcon={false}
            customIcon={<Icon svg="calendar" width={20} height={20} />}
            customIconPosition="right"
            className={inputClassName}
          />
        </button>
      </PopoverMenu>

      <ModalComponent
        isModalOpen={modalOpen && modal === "datePopOverMenuModal"}
        onModalClose={() => {
          handleModalClose();
        }}
        hasButtons={false}
        showMobileTopBar
        showHeader={false}
        closeOnOutsideClick
      >
        <DateComp
          clicked={clicked}
          date={date}
          minDate={minDate}
          referenceDate={referenceDate}
          setDate={setDate}
          className={className}
          disablePast={disablePast}
          disableFuture={disableFuture}
        />
      </ModalComponent>
    </>
  );
};
